/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum PolicyTermEnums {
    STANDARD_ONE_YEAR = 1,
    THREE_YEAR_FIXED_RATE = 2,
    SHORT_TERM = 4,
    OTHER = 8,
}
